import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { style: {"color":"wheat"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", null, "В настоящий момент игра находится на стадии разработки.", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", null, [
      _createTextVNode("В середине 2024-го года мы запустили "),
      _createElementVNode("span", { class: "highlighted" }, "закрытое бета-тестирование"),
      _createTextVNode(".")
    ], -1)),
    _cache[6] || (_cache[6] = _createElementVNode("p", null, [
      _createElementVNode("span", { class: "highlighted" }, "ЗБТ"),
      _createTextVNode(" продлится несколько месяцев. За это время мы подготовимся к полноценному запуску: устраним баги, скорректируем интерфейс, улучшим геймплей, отбалансируем экономическую модель.")
    ], -1)),
    _createElementVNode("p", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode("Ты можешь приобрести ")),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "highlighted" }, "пропуск на ЗБТ", -1)),
      _cache[3] || (_cache[3] = _createTextVNode(" на странице ")),
      _createVNode(_component_router_link, { to: "register" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("регистрации.")
        ])),
        _: 1
      })
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("p", null, "В качестве благодарности за поддержку проекта каждый из участников получит разнообразные награды при создании персонажа:", -1)),
    _cache[8] || (_cache[8] = _createElementVNode("ul", null, [
      _createElementVNode("li", null, "эксклюзивные аватарки и рамки"),
      _createElementVNode("li", null, "уникальные скины кораблей"),
      _createElementVNode("li", null, "звание «Первопроходца»"),
      _createElementVNode("li", null, "исследовательские зонды"),
      _createElementVNode("li", null, "бусты опыта"),
      _createElementVNode("li", null, "другие ценные бонусы")
    ], -1))
  ]))
}